@let vState = contacts();

<button
  class="button quaternary sm"
  [ariaLabel]="getNotificationsButtonAriaLabel()"
  [cdkMenuTriggerFor]="notificationsMenu">
  <div class="icon icon-bell icon-sm" aria-hidden="true"></div>

  @if (notificationsCount()) {
    <span class="badge text-white bg-violet-darkest">{{ notificationsCount() }}</span>
  }
</button>

<ng-template #notificationsMenu>
  <div cdkMenu class="menu">
    @if (vState.isLoading) {
      <div class="loading-spinner"></div>
      <p>Getting notifications...</p>
    } @else if (vState.error) {
      <p class="empty-content">Error loading notifications</p>
    } @else if (vState.data && vState.data.receivedRequests.length === 0) {
      <p class="empty-content">No notifications</p>
    } @else if (vState.data) {
      <ul class="at-notifications">
        @for (vRequest of vState.data.receivedRequests; track vRequest.user.userId) {
          <li class="at-notification">
            <p class="body-copy-md">New contact request from</p>

            <at-display-name showAvatar [user]="vRequest.user"></at-display-name>

            <button
              cdkMenuItem
              class="button primary sm"
              ariaLabel="Accept {{ vRequest.user.name }}'s contact request"
              (click)="acceptContactRequest(vRequest.user.userId)">
              <div class="icon icon-check" aria-hidden="true"></div>
              <span class="sr-only">Accept</span>
            </button>

            <button
              cdkMenuItem
              class="button secondary danger sm"
              ariaLabel="Decline {{ vRequest.user.name }}'s contact request"
              (click)="rejectContactRequest(vRequest.user.userId)">
              <div class="icon icon-trash" aria-hidden="true"></div>
              <span class="sr-only">Decline</span>
            </button>
          </li>
        }
      </ul>
    }
  </div>
</ng-template>
